(() => {
  'use strict';
  if (customElements.get('gerat-whatsapp')) return;

  const blockers = '.halo-sticky-toolbar-mobile, .productView-stickyCart, #halo-recently-viewed-popup, .halo-cookie, #shopify-pc__banner, .sticky-notification, form[action*="/cart/add"] [name="add"], .product-form__input';
  const overlayStates = '.cart-sidebar-show, .cart-popup-show, .menu_open, .menu_omenu_openpen, .open_search_mobile, .auth-sidebar-show, .lang-currency-sidebar-show, .quick-view-show, .quickshop-popup-show, .newsletter-show, .show-pickup-availability, .show-sidebar-content';
  const visible = element => {
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
  };

  class GeratWhatsApp extends HTMLElement {
    connectedCallback() {
      if (this.controller || document.querySelector('gerat-whatsapp') !== this) return;
      try { this.config = JSON.parse(this.querySelector('[data-gerat-wa-config]').textContent); }
      catch (_) { return; }
      const phone = this.normalizePhone(this.config.phone);
      if (!phone || this.config.previousChatHidden !== true) {
        const note = document.querySelector('[data-gerat-wa-note]');
        if (note) {
          note.hidden = false;
          note.textContent = !phone ? 'GERAT · WhatsApp: introduce el número internacional de la central.' : 'GERAT · WhatsApp: confirma que el chat anterior está oculto en este tema.';
        }
        return;
      }
      this.toggle = this.querySelector('[data-gw-toggle]');
      this.panel = this.querySelector('.gw-panel');
      this.start = this.querySelector('[data-gw-start]');
      this.closeButton = this.querySelector('[data-gw-close]');
      this.whatsappUrl = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(this.message());
      this.start.href = this.whatsappUrl;
      this.start.removeAttribute('aria-disabled');
      this.isOpen = false;
      this.panel.hidden = true;
      this.panel.inert = true;
      this.panel.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-gw-toggle]')) this.setOpen(!this.isOpen);
        else if (event.target.closest('[data-gw-close]')) this.setOpen(false);
        else if (event.target.closest('[data-gw-start]')) {
          this.track('whatsapp_widget_click');
          // Native target=_blank navigation; never open WhatsApp inside the editor frame.
        }
      }, {signal});
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.isOpen) {
          event.preventDefault();
          this.setOpen(false);
        } else if (event.key === 'Tab' && this.isOpen) {
          // Safari can skip native links with its default keyboard setting. Keep the
          // three controls in order while allowing Tab to leave this non-modal card.
          const controls = [this.closeButton, this.start, this.toggle];
          const index = controls.indexOf(document.activeElement);
          const next = index + (event.shiftKey ? -1 : 1);
          if (index >= 0 && next >= 0 && next < controls.length) {
            event.preventDefault();
            controls[next].focus();
          }
        }
      }, {signal});
      document.addEventListener('click', event => {
        if (this.isOpen && !this.contains(event.target)) this.setOpen(false, false);
      }, {signal});
      this.addEventListener('focusout', event => {
        if (this.isOpen && event.relatedTarget && !this.contains(event.relatedTarget)) this.setOpen(false, false);
      }, {signal});
      window.addEventListener('resize', () => this.schedule(), {signal, passive: true});
      window.addEventListener('scroll', () => this.schedule(), {signal, passive: true, capture: true});
      window.addEventListener('load', () => this.schedule(), {signal});
      window.visualViewport?.addEventListener('resize', () => this.schedule(), {signal, passive: true});
      this.observer = new MutationObserver(mutations => {
        if (mutations.some(mutation => !this.contains(mutation.target))) this.schedule();
      });
      this.observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open']});
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(document.body);
      this.loadPrivacy();
      this.position();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.closeTimer);
      this.frame = 0;
    }

    normalizePhone(value) {
      const raw = String(value || '').trim();
      if (!/^\+?[\d\s()-]+$/.test(raw)) return '';
      const phone = raw.replace(/[\s()+-]/g, '');
      return /^[1-9]\d{7,14}$/.test(phone) ? phone : '';
    }

    message() {
      const {messages = {}, pageType, productName, productUrl, collectionName} = this.config;
      const template = String(messages[pageType] || messages.general || '');
      let publicUrl = '';
      if (productUrl) {
        try {
          const url = new URL(productUrl);
          if (url.protocol === 'https:') {
            // Shopify visitor previews replace shop.url with an expiring preview host.
            const origin = url.hostname.endsWith('.shopifypreview.com') ? 'https://www.gerat.com.mx' : url.origin;
            publicUrl = origin + url.pathname;
          }
        } catch (_) { /* Never include a malformed or private URL in the message. */ }
      }
      const tokens = {producto: productName || '', url_producto: publicUrl, coleccion: collectionName || ''};
      return template.replace(/\{(producto|url_producto|coleccion)\}/g, (_, key) => tokens[key]);
    }

    setOpen(open, restoreFocus = true) {
      if (open === this.isOpen) return;
      this.isOpen = open;
      clearTimeout(this.closeTimer);
      this.toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        this.panel.hidden = false;
        this.panel.inert = false;
        // Establish the initial opacity before starting the short opening transition.
        void this.panel.offsetHeight;
        this.panel.classList.add('is-open');
        this.closeButton.focus({preventScroll: true});
      } else {
        if (restoreFocus && this.contains(document.activeElement)) this.toggle.focus({preventScroll: true});
        this.panel.inert = true;
        this.panel.classList.remove('is-open');
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 160;
        if (!duration) this.panel.hidden = true;
        else this.closeTimer = setTimeout(() => { this.panel.hidden = true; this.schedule(); }, duration);
      }
      this.track(open ? 'whatsapp_widget_open' : 'whatsapp_widget_close');
      this.schedule();
    }

    loadPrivacy() {
      if (!this.config.analytics || this.config.designMode || window.Shopify?.customerPrivacy) return;
      try { window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.2'}], () => {}); }
      catch (_) { /* An unavailable privacy API disables measurement, never chat. */ }
    }

    track(event) {
      if (!this.config.analytics || this.config.designMode) return;
      try {
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
        if (!Array.isArray(window.dataLayer)) return;
        const mobile = matchMedia('(max-width: 1024px)').matches;
        const product = this.config.pageType === 'product';
        window.dataLayer.push({
          event,
          page_type: this.config.pageType,
          product_id: product ? String(this.config.productId || '') : null,
          product_name: product ? this.config.productName : null,
          widget_location: 'bottom_' + (mobile ? this.dataset.mobileSide : this.dataset.desktopSide),
          viewport: mobile ? 'mobile' : 'desktop'
        });
      } catch (_) { /* Tracking cannot interrupt navigation to WhatsApp. */ }
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.position(); });
    }

    position() {
      if (!this.isConnected) return;
      const modalOpen = document.body.matches(overlayStates) || [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(element => !this.contains(element) && visible(element));
      if (modalOpen) {
        if (this.isOpen) this.setOpen(false, false);
        this.hidden = true;
        return;
      }
      this.hidden = false;
      // Recompute from the configured position; never move other theme controls.
      this.style.setProperty('--gw-lift', '0px');
      const origin = this.toggle.getBoundingClientRect();
      let lift = 0;
      const obstacles = [...document.querySelectorAll(blockers)].filter(visible).map(element => element.getBoundingClientRect());
      // Shopify's transparent preview iframe spans the viewport; only reserve its bottom bar.
      const previewBar = document.querySelector('#PBarNextFrame, #preview-bar-iframe');
      if (previewBar && visible(previewBar)) obstacles.push({left: 0, right: innerWidth, top: innerHeight - 72, bottom: innerHeight});
      // Several bars can be stacked. Revisit their rectangles until no overlap remains.
      for (let pass = 0; pass <= obstacles.length; pass++) {
        const previous = lift;
        for (const rect of obstacles) {
          if (origin.right + 8 > rect.left && origin.left - 8 < rect.right && origin.bottom - lift + 8 > rect.top && origin.top - lift - 8 < rect.bottom) {
            lift = Math.max(lift, origin.bottom - rect.top + 12);
          }
        }
        if (previous === lift) break;
      }
      this.style.setProperty('--gw-lift', Math.ceil(lift) + 'px');
      if (origin.top - lift < 12) {
        if (this.isOpen) this.setOpen(false, false);
        this.hidden = true;
        return;
      }
      if (this.isOpen) this.placePanel(obstacles);
    }

    placePanel(obstacles) {
      const rect = this.panel.getBoundingClientRect();
      // Leave purchase/variant controls and fixed bars operable while chat is open.
      const ceiling = (window.visualViewport?.offsetTop || 0) + 16;
      const floor = this.toggle.getBoundingClientRect().top - 24;
      const intervals = obstacles.filter(box => box.right > rect.left && box.left < rect.right && box.bottom > ceiling && box.top < floor)
        .map(box => [Math.max(ceiling, box.top - 12), Math.min(floor, box.bottom + 12)])
        .sort((a, b) => a[0] - b[0]);
      const gaps = [];
      let cursor = ceiling;
      for (const [top, bottom] of intervals) {
        if (top > cursor) gaps.push([cursor, top]);
        cursor = Math.max(cursor, bottom);
      }
      if (cursor < floor) gaps.push([cursor, floor]);
      const desired = Math.min(this.panel.scrollHeight + 2, (window.visualViewport?.height || innerHeight) * .7, 520);
      const sufficient = gaps.filter(([top, bottom]) => bottom - top >= Math.min(desired, 180));
      const slot = sufficient.at(-1) || gaps.sort((a, b) => (b[1] - b[0]) - (a[1] - a[0]))[0];
      if (!slot) return;
      const room = Math.max(0, Math.floor(slot[1] - slot[0]));
      this.style.setProperty('--gw-panel-room', room + 'px');
      this.style.setProperty('--gw-panel-shift', Math.max(0, Math.ceil(floor - slot[1])) + 'px');
      this.panel.toggleAttribute('data-compact', room < 200);
    }
  }
  customElements.define('gerat-whatsapp', GeratWhatsApp);
})();
